// import React, { useState } from "react";
// import Loader from "../utils/loader";
// import clsx from "clsx";
// import { makeStyles } from "@material-ui/core/styles";
// import TextField from "@material-ui/core/TextField";
// import image1 from "../static/Group5702x.png";
// import bgImage from "../static/Group244.png";
// import { toast, ToastContainer } from "react-toastify";
// import CryptoJS from "crypto-js";
// import authService from "../services/authService.js";
// import { Link, withRouter } from "react-router-dom";
// // import FormControl from "@material-ui/core/FormControl";
// import IconButton from "@material-ui/core/IconButton";
// import Input from "@material-ui/core/Input";
// import InputLabel from "@material-ui/core/InputLabel";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import Visibility from "@material-ui/icons/Visibility";
// import VisibilityOff from "@material-ui/icons/VisibilityOff";
// import "./LoginForm.css";
// import { useEffect } from "react";
// import { connect } from "react-redux";
// import { setCurrentUser } from "../redux/user/user.actions";
// import { setUserFeatures } from "../redux/features/features.action";
// import { getHomeCMS } from "../services/adminServices";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   Card,
//   InputGroup,
//   FormControl,
//   Form,
//   Button,
//   ButtonGroup,
//   Carousel,
// } from "react-bootstrap";
// import loginBackground from "../static/loginBackground.png";
// import Login1 from "../static/login-1.png";
// import Login2 from "../static/login-2.png";
// import Login3 from "../static/signupBg.png";
// import PetLogo from "../static/POET_Logo_Mid.png";
// import googleSignin from "../static/signup_login/googleSignin.png";
// import facebookSignin from "../static/signup_login/facebookSignin.png";
// import microsoft365Signin from "../static/signup_login/microsoft365Signin.png";
// import InputBoxMui from "./ReusableComponents/InputBoxMui.jsx";
// import CheckboxMui from "./ReusableComponents/CheckBoxMui.jsx";
// import InputBoxPasswordMui from "./ReusableComponents/InputBoxPasswordMui.jsx";
// import configdata from "../services/config.json";
// import { useParams } from "react-router-dom/cjs/react-router-dom.min.js";
// import { userIsConfirmed } from "../services/userConfirmationServices.js";
// import ChatServices from "../services/ChatServices.js";
// import { addUserLogs } from "../services/userLogServices.js";
// import { getFeatures } from "../services/roleServices.js";
// import { setRoleFeatures } from "../redux/roleFeatures/roleFeatures.action.js";
// import { setSubscriptionPlan } from "../redux/subscriptionPlan/subscriptionPlan.action.js";
// // import lastVisitedReducer from "../redux/lastVisited/lastVisited.reducer.js";
// import PoetNewlogopen from "../static/loginlogo.png";

// const useStyles = makeStyles((theme) => ({
//   // container: {
//   //   display: "flex",
//   //   flexWrap: "wrap",
//   // },
//   // textField: {
//   //   marginLeft: theme.spacing(1),
//   //   marginRight: theme.spacing(1),
//   //   width: "100%",
//   // },
//   // dense: {
//   //   marginTop: 19,
//   // },
// }));

// function Login({ history, setCurrentUser, currentUser, setUserFeatures }) {
//   const classes = useStyles();
//   const facebookUrl = `${configdata.apiUrl}/api/auth/facebook`;
//   let [email, setEmail] = useState("");
//   const [values, setValues] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading, showPassword] = useState(false);
//   const [isRememberMe, setRemeberMe] = useState(false);
//   const [emailerrors, setEmailErrors] = useState("");
//   const [passerrors, setPassErrors] = useState("");
//   const [cms, setCms] = useState({});
//   // const { confirmEmail, token } = useParams()

//   const { loginParam } = useParams();
//   const dispatch = useDispatch();

//   useEffect(() => {
//     console.log("loginformvalue", loginParam);
//     if (undefined !== loginParam && loginParam !== "") {
//       toast.success("Email Verification is Successful");
//     }
//   }, [loginParam]);

//   // useEffect(() => {
//   //     if (undefined !== confirmEmail && undefined !== token) {
//   //         handleVerify(confirmEmail, token)
//   //     }
//   // }, [confirmEmail])

//   // const handleVerify = async () => {
//   //     setLoading(true)
//   //     try {
//   //         let response = await userIsConfirmed(confirmEmail, token)
//   //         if (response.status == 200) {
//   //             // toast.success(response.message)
//   //             toast.success("Email Verification is Successful")
//   //         }
//   //         else {
//   //             toast.info(response.message)
//   //         }
//   //     }
//   //     catch (error) {
//   //         console.log("error", error)
//   //     }
//   //     setLoading(false)
//   // }

//   async function handleEmail(e) {
//     let email = e.target.value;
//     setEmail(e.target.value);
//     console.log(email);
//     // var reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
//     const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+[a-zA-Z]$/;
//     if (email === "") {
//       setEmailErrors("Email is not allowed to be empty.");
//     } else {
//       setEmailErrors("");
//       console.log("email_", reg.test(email));
//       if (reg.test(email) === false) {
//         setEmailErrors("Invalid Email.");
//       } else {
//         setEmailErrors(" ");
//       }
//       //  setPassword(password);
//     }
//   }
//   async function handlePassword(e) {
//     let password = e.target.value;
//     if (password === "") {
//       setPassErrors("Password is not allowed to be empty.");
//     } else {
//       setPassErrors("");
//       setPassword(password);
//     }
//   }

//   async function handleLogin() {
//     try {
//       setLoading(true);

//       const hashedPassword = CryptoJS.SHA256(password).toString();

//       const userEntry = {
//         email: email.toLowerCase(),
//         password: hashedPassword,
//       };

//       const response = await authService.login(userEntry);
//       console.log("handleLoginResponse", response);

//       if (response.status !== 200) {
//         toast.error(response.message);
//         return;
//       }
//       // ✅ Remove only token (do NOT clear everything)
//       localStorage.removeItem("token");
//       sessionStorage.removeItem("token");

//       const { user, subscriptionPlan } = response;

//       // STORE TOKEN
//       localStorage.setItem("token", response.token);
//       sessionStorage.setItem("token", response.token);

//       // STORE USER DATA
//       localStorage.setItem("organizationId", user.organizationId);
//       localStorage.setItem("userId", user._id);
//       localStorage.setItem("accountType", user.accountType);
//       localStorage.setItem("Role", user.Role);
//       localStorage.setItem("currentUserEmail", userEntry.email);

//       sessionStorage.setItem("organizationId", user.organizationId);
//       sessionStorage.setItem("userId", user._id);
//       sessionStorage.setItem("accountType", user.accountType);
//       sessionStorage.setItem("Role", user.Role);
//       sessionStorage.setItem("currentUserEmail", userEntry.email);
//       sessionStorage.setItem(
//         "subscriptionPlan",
//         JSON.stringify(subscriptionPlan),
//       );

//       // UPDATE REDUX
//       dispatch(setCurrentUser(user));
//       dispatch(setSubscriptionPlan(subscriptionPlan));

//       // FETCH FEATURES
//       const featureResponse = await getFeatures(user._id);
//       if (featureResponse?.Features) {
//         sessionStorage.setItem(
//           "Features",
//           JSON.stringify(featureResponse.Features),
//         );
//         dispatch(setRoleFeatures(featureResponse.Features));
//       }

//       // SET USER ONLINE
//       await ChatServices.setStatus(user._id, "Online");

//       // LOG USER ACTIVITY
//       try {
//         await addUserLogs({
//           userId: user._id,
//           organizationId: user.organizationId,
//           actionType: "login",
//         });
//       } catch {
//         toast.error("Error in saving user logs.");
//       }

//       if (user.isAdmin && !user.isSubAdmin) {
//         history.push("/admindashboard");
//       } else if (!user.isAdmin && !user.isSubAdmin) {
//         // history.push("/dashboard");
//         window.location.href = "/dashboard";
//       } else {
//         history.push("/subAdminDashboard");
//       }
//     } catch (err) {
//       toast.error("Login failed");
//     } finally {
//       setLoading(false);
//     }
//   }

//   const getCms = async () => {
//     let cms = await getHomeCMS();
//     setCms(cms.data);
//     console.log(cms);
//   };

//   // useEffect(() => {
//   //   if (localStorage.getItem("rememberMe")) {
//   //     history.push("/login");
//   //   }
//   //   getCms();
//   //   // return () => toast.dismiss();
//   // }, []);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const isGuest = localStorage.getItem("is_guest") === "true";

//     if (token && !isGuest && history.location.pathname === "/login") {
//       history.push("/dashboard");
//     }

//     getCms();
//   }, []);

//   function _handleKeyDown(e) {
//     if (e.key === "Enter") {
//       handleLogin();
//     }
//   }

//   const handleClickShowPassword = () => {
//     setValues({ ...values, showPassword: !values.showPassword });
//   };

//   const handleMouseDownPassword = (event) => {
//     event.preventDefault();
//   };
//   const handleRememberMe = (e) => {
//     const isRememberMe = e.target.checked;
//     // if (isRememberMe) {
//     //     localStorage.setItem("rememberMe", true);
//     // } else {
//     //     localStorage.setItem("rememberMe", false);
//     // }
//     setRemeberMe(isRememberMe);
//   };
//   function statusChangeCallback(response) {
//     // Called with the results from FB.getLoginStatus().
//     console.log("statusChangeCallback");
//     console.log(response); // The current login status of the person.
//     if (response.status === "connected") {
//       // Logged into your webpage and Facebook.
//       testAPI();
//     } else {
//       // Not logged into your webpage or we are unable to tell.
//       document.getElementById("status").innerHTML =
//         "Please log " + "into this webpage.";
//     }
//   }

//   function checkLoginState() {
//     // Called when a person is finished with the Login Button.
//     window.FB.getLoginStatus(function (response) {
//       // See the onlogin handler
//       statusChangeCallback(response);
//     });
//   }

//   // window.fbAsyncInit = function () {
//   //     window.FB.init({
//   //         appId: "2516433218621372",
//   //         cookie: true, // Enable cookies to allow the server to access the session.
//   //         xfbml: true, // Parse social plugins on this webpage.
//   //         version: "v8.0", // Use this Graph API version for this call.
//   //     });

//   //     window.FB.getLoginStatus(function (response) {
//   //         // Called after the JS SDK has been initialized.
//   //         statusChangeCallback(response); // Returns the login status.
//   //     });
//   // };

//   (function (d, s, id) {
//     // Load the SDK asynchronously
//     var js,
//       fjs = d.getElementsByTagName(s)[0];
//     if (d.getElementById(id)) return;
//     js = d.createElement(s);
//     js.id = id;
//     js.src = "https://connect.facebook.net/en_US/sdk.js";
//     fjs.parentNode.insertBefore(js, fjs);
//   })(document, "script", "facebook-jssdk");

//   function testAPI() {
//     // Testing Graph API after login.  See statusChangeCallback() for when this call is made.
//     console.log("Welcome!  Fetching your information.... ");
//     window.FB.api("/me", function (response) {
//       console.log("Successful login for: " + response.name);
//       document.getElementById("status").innerHTML =
//         "Thanks for logging in, " + response.name + "!";
//     });
//   }

//   return (
//     <div
//       className="container-fluid-login"
//       style={{
//         backgroundImage: `url(${Login1})`,
//         backgroundSize: "cover",
//         backgroundRepeat: "no-repeat",
//         backgroundPosition: "center",
//         height: "100%",
//         position: "absolute",
//         top: 0,
//         left: 0,
//         // position: "relative"
//       }}
//     >
//       <Loader loading={loading} />

//       <div className="d-flex col-md-12 align-items-center">
//         {/* Logo Section */}
//         <div className="petLogoContainer">
//           <Link to="/">
//             <img src={PoetNewlogopen} alt="Logo" className="petLogo" />
//           </Link>
//         </div>

//         {/* Login Card */}
//         <div className=" col-md-12">
//           <div className="col-sm-12 col-md-12 col-lg-12 d-flex justify-content-center">
//             <Card className="card-comp px-5 py-4">
//               <h3 className="mainHeading text-center">Login</h3>

//               {/* Email Field */}
//               <div className="mt-3">
//                 <InputBoxMui
//                   fullWidth
//                   type="email"
//                   label="Email"
//                   value={email}
//                   onChange={handleEmail}
//                   autoComplete="off"
//                 />
//                 <p
//                   style={{ color: "red", fontSize: "10px", textAlign: "left" }}
//                 >
//                   {emailerrors}
//                 </p>
//               </div>

//               {/* Password Field */}
//               <div className="mt-3">
//                 <InputBoxPasswordMui
//                   fullWidth
//                   label="Password"
//                   type={values.showPassword ? "text" : "password"}
//                   value={values.password}
//                   onChange={handlePassword}
//                   autoComplete="off"
//                 />
//                 <p
//                   style={{ color: "red", fontSize: "10px", textAlign: "left" }}
//                 >
//                   {passerrors}
//                 </p>
//               </div>

//               {/* Remember & Forgot */}
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <CheckboxMui
//                   label="Remember Me"
//                   isChecked={isRememberMe}
//                   onChange={handleRememberMe}
//                 />
//                 <Link to="/forgotpassword" className="forgotpass">
//                   Forgot Password?
//                 </Link>
//               </div>

//               {/* Login Button */}
//               <div className="text-center">
//                 <Button
//                   variant="primary"
//                   className="loginBtn"
//                   onClick={handleLogin}
//                 >
//                   Login
//                 </Button>
//               </div>

//               {/* Divider */}
//               <p className="hr-lines mt-3">OR</p>

//               {/* Google */}
//               <Button
//                 className="smBtn mt-1"
//                 href={`${configdata.apiUrl}/auth/google/callback`}
//               >
//                 <img className="smImg" src={googleSignin} alt="Google" />
//                 <span className="googlefblink">
//                   Login with <strong>Google</strong>
//                 </span>
//               </Button>

//               {/* Facebook */}
//               <Button
//                 className="smBtn mt-2"
//                 href={`${configdata.apiUrl}/auth/facebook`}
//               >
//                 <img className="smImg" src={facebookSignin} alt="Facebook" />
//                 <span className="googlefblink">
//                   Login with <strong>Facebook</strong>
//                 </span>
//               </Button>

//               {/* Microsoft 365 */}
//               <Button
//                 className="smBtn mt-2"
//                 href={`${configdata.apiUrl}/auth/microsoft`}
//               >
//                 <img
//                   className="smImg"
//                   height={30}
//                   src={microsoft365Signin}
//                   alt="Microsoft"
//                 />
//                 <span className="googlefblink">
//                   Login with <strong>Microsoft 365</strong>
//                 </span>
//               </Button>

//               {/* Signup */}
//               <p className="text-center mt-3">
//                 Don&apos;t have an account?{" "}
//                 <Link to="/signup" className="signinLink">
//                   Sign-up
//                 </Link>
//               </p>

//               {/* Policy Links */}
//               <p className="text-center mt-2">
//                 <Link
//                   to="/privacypolicy"
//                   target="_blank"
//                   className="privacyLink"
//                 >
//                   Terms of use. Privacy policy
//                 </Link>
//               </p>
//             </Card>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// const mapDispatchToProps = (dispatch) => ({
//   setCurrentUser: (user) => dispatch(setCurrentUser(user)),
//   setUserFeatures: (features) => dispatch(setUserFeatures(features)),
//   setRoleFeatures: (roleFeatures) => dispatch(setRoleFeatures(roleFeatures)),
//   setSubscriptionPlan: (plan) => dispatch(setSubscriptionPlan(plan)),
// });

// export default connect(null, mapDispatchToProps)(withRouter(Login));

import React, { useState, useEffect, useRef } from "react";
import Loader from "../utils/loader";
import { toast, ToastContainer } from "react-toastify";
import CryptoJS from "crypto-js";
import authService from "../services/authService.js";
import { Link, withRouter } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import { setCurrentUser } from "../redux/user/user.actions";
import { setUserFeatures } from "../redux/features/features.action";
import { getHomeCMS } from "../services/adminServices";
import { useParams } from "react-router-dom/cjs/react-router-dom.min.js";
import ChatServices from "../services/ChatServices.js";
import { addUserLogs } from "../services/userLogServices.js";
import { getFeatures } from "../services/roleServices.js";
import { setRoleFeatures } from "../redux/roleFeatures/roleFeatures.action.js";
import { setSubscriptionPlan } from "../redux/subscriptionPlan/subscriptionPlan.action.js";
import configdata from "../services/config.json";

import {
  Box,
  TextField,
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Grid,
} from "@mui/material";
import { Visibility, VisibilityOff, Email, Lock } from "@mui/icons-material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import PoetNewlogopen from "../static/loginlogo.png";
import googleSignin from "../static/signup_login/googleSignin.png";
import facebookSignin from "../static/signup_login/facebookSignin.png";
import microsoft365Signin from "../static/signup_login/microsoft365Signin.png";

const theme = createTheme({
  palette: { primary: { main: "#1976D2" } },
  typography: { fontFamily: "'Cormorant Garamond', Georgia, serif" },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& label": {
            color: "#000000",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "0.95rem",
            fontWeight: 700,
            letterSpacing: "0.08em",
          },
          "& label.Mui-focused": { color: "#2196F3", fontWeight: 700 },
          "& .MuiOutlinedInput-notchedOutline legend": {
            width: "auto",
            
          },

          "& .MuiOutlinedInput-notchedOutline legend span": {
            paddingLeft: "9px",
            paddingRight: "9px",
          },
          "& .MuiOutlinedInput-root": {
            color: "#000000",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "0.88rem",
            background: "rgba(255,255,255,0.9)",
            borderRadius: "12px",
            "& fieldset": {
              borderColor: "rgba(25,118,210,0.3)",
              borderRadius: "12px",
            },
            "&:hover fieldset": { borderColor: "#1976D2" },
            "&.Mui-focused fieldset": {
              borderColor: "#2196F3",
              borderWidth: "2px",
            },
          },
          "& .MuiInputAdornment-root svg": { color: "#1976D2" },
        },
      },
    },
  },
});

function AnimatedBackground() {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 0,
        overflow: "hidden",
        pointerEvents: "none",
      }}
    >
      <style>{`
        /* ── Keyframes ── */
        @keyframes floatUp    { 0%,100%{transform:translateY(0)   rotate(0deg)}   50%{transform:translateY(-28px) rotate(8deg)} }
        @keyframes floatDown  { 0%,100%{transform:translateY(0)   rotate(0deg)}   50%{transform:translateY(22px)  rotate(-6deg)} }
        @keyframes floatSide  { 0%,100%{transform:translateX(0)   rotate(0deg)}   50%{transform:translateX(24px)  rotate(10deg)} }
        @keyframes spin3d     { 0%{transform:rotateY(0deg) rotateX(15deg) scale(1)}
                                50%{transform:rotateY(180deg) rotateX(-10deg) scale(1.08)}
                                100%{transform:rotateY(360deg) rotateX(15deg) scale(1)} }
        @keyframes spinSlow   { 0%{transform:rotate(0deg)} 100%{transform:rotate(360deg)} }
        @keyframes spinReverse{ 0%{transform:rotate(0deg)} 100%{transform:rotate(-360deg)} }
        @keyframes jump       { 0%,100%{transform:translateY(0) scaleY(1)}
                                40%{transform:translateY(-40px) scaleY(1.05)}
                                60%{transform:translateY(-38px) scaleY(1.05)}
                                80%{transform:translateY(-4px)  scaleY(0.96)} }
        @keyframes jumpShadow { 0%,100%{transform:scaleX(1); opacity:0.35}
                                40%,60%{transform:scaleX(0.55); opacity:0.12} }
        @keyframes pulse3d    { 0%,100%{transform:scale(1);    opacity:0.7}
                                50%{transform:scale(1.18); opacity:1} }
        @keyframes orbit      { 0%{transform:rotate(0deg) translateX(54px) rotate(0deg)}
                                100%{transform:rotate(360deg) translateX(54px) rotate(-360deg)} }
        @keyframes orbitRev   { 0%{transform:rotate(0deg) translateX(38px) rotate(0deg)}
                                100%{transform:rotate(-360deg) translateX(38px) rotate(360deg)} }
        @keyframes shimmerBg  { 0%{background-position:0% 50%} 50%{background-position:100% 50%} 100%{background-position:0% 50%} }
        @keyframes waveFloat  { 0%,100%{d:path("M0,60 Q200,20 400,60 Q600,100 800,60 L800,150 L0,150 Z")}
                                50%{d:path("M0,80 Q200,120 400,80 Q600,40 800,80 L800,150 L0,150 Z")} }
      @keyframes twinkle    { 0%,100%{opacity:1; r:2} 50%{opacity:0.2; r:1} }
        @keyframes dashAnim   { to{stroke-dashoffset:0} }
        @keyframes bounce3    { 0%,100%{transform:translateY(0)} 30%{transform:translateY(-22px)} 60%{transform:translateY(-8px)} }
        @keyframes sway       { 0%,100%{transform:rotate(-8deg)} 50%{transform:rotate(8deg)} }

        /* ── Element classes ── */
        .bg-float-1  { animation: floatUp    5.2s ease-in-out infinite; }
        .bg-float-2  { animation: floatDown  6.8s ease-in-out infinite; }
        .bg-float-3  { animation: floatSide  4.5s ease-in-out infinite; }
        .bg-float-4  { animation: floatUp    7.1s ease-in-out infinite 1s; }
        .bg-float-5  { animation: floatDown  5.8s ease-in-out infinite 2s; }
        .bg-spin-cw  { animation: spinSlow   8s   linear    infinite; }
        .bg-spin-ccw { animation: spinReverse 12s  linear    infinite; }
        .bg-spin-3d  { animation: spin3d     6s   ease-in-out infinite; transform-style:preserve-3d; }
        .bg-jump     { animation: jump       2.4s  cubic-bezier(0.28,0.84,0.42,1) infinite; }
        .bg-jump2    { animation: jump       3.1s  cubic-bezier(0.28,0.84,0.42,1) infinite 0.6s; }
        .bg-jump3    { animation: bounce3    2.8s  ease-in-out infinite 1.2s; }
        .bg-pulse    { animation: pulse3d    3.5s  ease-in-out infinite; }
        .bg-orbit    { animation: orbit      4s    linear    infinite; }
        .bg-orbit2   { animation: orbitRev   6s    linear    infinite; }
        .bg-sway     { animation: sway       3.2s  ease-in-out infinite; transform-origin: 50% 0; }
        .twinkle     { animation: twinkle    2s    ease-in-out infinite; }
        .twinkle2    { animation: twinkle    3.5s  ease-in-out infinite 1s; }
        .twinkle3    { animation: twinkle    2.8s  ease-in-out infinite 0.5s; }
      `}</style>

      <svg
        width="100%"
        height="100%"
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: "absolute", inset: 0 }}
      >
        <defs>
          {/* Background gradient — white/light blue */}
          <linearGradient id="bgGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FFFFFF" />
            <stop offset="30%" stopColor="#F0F8FF" />
            <stop offset="65%" stopColor="#E1F0FA" />
            <stop offset="100%" stopColor="#B8E0FF" />
          </linearGradient>

          {/* Blue shimmer gradient */}
          <linearGradient id="blueShimmer" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#2196F3" stopOpacity="0.9" />
            <stop offset="40%" stopColor="#64B5F6" stopOpacity="1" />
            <stop offset="70%" stopColor="#1976D2" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#0D47A1" stopOpacity="0.8" />
          </linearGradient>

          {/* Light blue fill */}
          <linearGradient id="lightBlue" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#E3F2FD" stopOpacity="0.95" />
            <stop offset="100%" stopColor="#BBDEFB" stopOpacity="0.6" />
          </linearGradient>

          {/* Deep blue */}
          <linearGradient id="deepBlue" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0D47A1" />
            <stop offset="50%" stopColor="#1976D2" />
            <stop offset="100%" stopColor="#0D47A1" />
          </linearGradient>

          {/* Glow filter */}
          <filter id="glow" x="-30%" y="-30%" width="160%" height="160%">
            <feGaussianBlur stdDeviation="6" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <filter id="softGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="12" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <filter id="shadow3d">
            <feDropShadow
              dx="4"
              dy="8"
              stdDeviation="6"
              floodColor="#1976D2"
              floodOpacity="0.3"
            />
          </filter>

          {/* Shield clip */}
          <clipPath id="shieldClip">
            <path d="M24,2 L46,12 L46,28 C46,38 36,46 24,50 C12,46 2,38 2,28 L2,12 Z" />
          </clipPath>
        </defs>

        {/* ── BASE BACKGROUND ── */}
        <rect width="1440" height="900" fill="url(#bgGrad)" />

        {/* Soft radial glows */}
        <ellipse
          cx="200"
          cy="180"
          rx="320"
          ry="220"
          fill="#2196F3"
          opacity="0.06"
        />
        <ellipse
          cx="1240"
          cy="720"
          rx="280"
          ry="200"
          fill="#1976D2"
          opacity="0.07"
        />
        <ellipse
          cx="720"
          cy="450"
          rx="400"
          ry="300"
          fill="#64B5F6"
          opacity="0.04"
        />
        <ellipse
          cx="100"
          cy="800"
          rx="180"
          ry="120"
          fill="#2196F3"
          opacity="0.05"
        />
        <ellipse
          cx="1380"
          cy="100"
          rx="200"
          ry="140"
          fill="#1976D2"
          opacity="0.05"
        />

        {/* ── WAVE / TERRAIN ── */}
        <g opacity="0.12">
          <path
            d="M0,820 Q360,760 720,820 Q1080,880 1440,820 L1440,900 L0,900 Z"
            fill="url(#deepBlue)"
          />
          <path
            d="M0,840 Q360,800 720,840 Q1080,875 1440,840 L1440,900 L0,900 Z"
            fill="url(#blueShimmer)"
            opacity="0.5"
          />
        </g>

        {/* ── GRID LINES (perspective) ── */}
        <g
          stroke="#1976D2"
          strokeWidth="0.5"
          opacity="0.1"
          strokeDasharray="6 8"
        >
          {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
            <line key={`h${i}`} x1="0" y1={i * 112} x2="1440" y2={i * 112} />
          ))}
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
            <line key={`v${i}`} x1={i * 160} y1="0" x2={i * 160} y2="900" />
          ))}
        </g>

        {/* ══════════════════════════════════════════════
            3D FLOATING SHIELD (top-left) — BOUNCING
        ══════════════════════════════════════════════ */}
        <g
          transform="translate(120, 80)"
          className="bg-jump"
          filter="url(#shadow3d)"
        >
          <ellipse
            cx="55"
            cy="75"
            rx="30"
            ry="5"
            fill="#1976D2"
            opacity="0.15"
          />
        </g>

        {/* ══════════════════════════════════════════════
            FLOATING USER AVATAR CARDS (right side)
        ══════════════════════════════════════════════ */}
        {/* Card 1 */}
        <g
          transform="translate(1160, 120)"
          className="bg-float-2"
          filter="url(#shadow3d)"
        >
          <rect
            width="160"
            height="90"
            rx="16"
            fill="white"
            opacity="0.88"
            stroke="url(#blueShimmer)"
            strokeWidth="1.5"
          />
          {/* avatar circle */}
          <circle
            cx="36"
            cy="38"
            r="22"
            fill="url(#lightBlue)"
            stroke="#1976D2"
            strokeWidth="2"
          />
          <circle cx="36" cy="30" r="9" fill="#1976D2" opacity="0.8" />
          <path d="M18,58 Q36,46 54,58" fill="#1976D2" opacity="0.7" />
          {/* text lines */}
          <rect
            x="66"
            y="26"
            width="78"
            height="8"
            rx="4"
            fill="#1976D2"
            opacity="0.5"
          />
          <rect
            x="66"
            y="42"
            width="55"
            height="6"
            rx="3"
            fill="#1976D2"
            opacity="0.3"
          />
          {/* green dot */}
          <circle cx="145" cy="18" r="7" fill="#4CAF50" opacity="0.9" />
          <text x="145" y="22" textAnchor="middle" fontSize="8" fill="white">
            ✓
          </text>
          {/* Blue top bar */}
          <rect
            width="160"
            height="6"
            rx="3"
            fill="url(#blueShimmer)"
            opacity="0.6"
          />
        </g>

        {/* ══════════════════════════════════════════════
            TWINKLING STARS scattered
        ══════════════════════════════════════════════ */}
        {[
          { cx: 320, cy: 60, r: 3, cls: "twinkle" },
          { cx: 900, cy: 30, r: 2, cls: "twinkle2" },
          { cx: 450, cy: 150, r: 2.5, cls: "twinkle3" },
          { cx: 1100, cy: 200, r: 2, cls: "twinkle" },
          { cx: 200, cy: 500, r: 3, cls: "twinkle2" },
          { cx: 800, cy: 750, r: 2, cls: "twinkle3" },
          { cx: 1050, cy: 620, r: 2.5, cls: "twinkle" },
          { cx: 580, cy: 300, r: 2, cls: "twinkle2" },
          { cx: 370, cy: 820, r: 3, cls: "twinkle3" },
          { cx: 1280, cy: 450, r: 2, cls: "twinkle" },
          { cx: 70, cy: 240, r: 2.5, cls: "twinkle2" },
          { cx: 960, cy: 500, r: 2, cls: "twinkle3" },
        ].map((s, i) => (
          <circle
            key={i}
            cx={s.cx}
            cy={s.cy}
            r={s.r}
            fill="#1976D2"
            className={s.cls}
            filter="url(#glow)"
          />
        ))}
      </svg>
    </Box>
  );
}

function Login({ history, setCurrentUser, currentUser, setUserFeatures }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRememberMe, setRememberMe] = useState(false);
  const [emailerrors, setEmailErrors] = useState("");
  const [passerrors, setPassErrors] = useState("");
  const [cms, setCms] = useState({});

  // Refs to track input focus
  const emailInputRef = useRef(null);
  const passwordInputRef = useRef(null);

  const { loginParam } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (loginParam) toast.success("Email Verification is Successful");
  }, [loginParam]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const isGuest = localStorage.getItem("is_guest") === "true";
    if (token && !isGuest && history.location.pathname === "/login")
       window.location.href = "/dashboard";
    getCms();
  }, []);

  // FIXED: Handle email change without causing cursor issues
  async function handleEmail(e) {
    const v = e.target.value;
    setEmail(v);

    // Use setTimeout to delay validation and prevent cursor jump
    setTimeout(() => {
      const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+[a-zA-Z]$/;
      if (!v) setEmailErrors("Email is not allowed to be empty.");
      else if (!reg.test(v)) setEmailErrors("Invalid Email.");
      else setEmailErrors(" ");
    }, 0);
  }

  // FIXED: Handle password change without causing cursor issues
  async function handlePassword(e) {
    const v = e.target.value;
    setPassword(v);

    // Use setTimeout to delay validation and prevent cursor jump
    setTimeout(() => {
      if (!v) setPassErrors("Password is not allowed to be empty.");
      else setPassErrors("");
    }, 0);
  }

  // FIXED: Email blur validation
  const handleEmailBlur = () => {
    const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+[a-zA-Z]$/;
    if (!email) setEmailErrors("Email is not allowed to be empty.");
    else if (!reg.test(email)) setEmailErrors("Invalid Email.");
    else setEmailErrors(" ");
  };

  // FIXED: Password blur validation
  const handlePasswordBlur = () => {
    if (!password) setPassErrors("Password is not allowed to be empty.");
    else setPassErrors("");
  };

  async function handleLogin() {
    try {
      setLoading(true);
      const hashedPassword = CryptoJS.SHA256(password).toString();
      const userEntry = {
        email: email.toLowerCase(),
        password: hashedPassword,
      };
      const response = await authService.login(userEntry);
      if (response.status !== 200) {
        toast.error(response.message);
        return;
      }

      localStorage.removeItem("token");
      sessionStorage.removeItem("token");

      const { user, subscriptionPlan } = response;
      localStorage.setItem("token", response.token);
      sessionStorage.setItem("token", response.token);
      [
        "organizationId",
        "userId",
        "accountType",
        "Role",
        "currentUserEmail",
      ].forEach((k) => {
        const val =
          k === "currentUserEmail"
            ? userEntry.email
            : user[k === "userId" ? "_id" : k];
        localStorage.setItem(k, val);
        sessionStorage.setItem(k, val);
      });
      sessionStorage.setItem(
        "subscriptionPlan",
        JSON.stringify(subscriptionPlan),
      );

      dispatch(setCurrentUser(user));
      dispatch(setSubscriptionPlan(subscriptionPlan));

      const featureResponse = await getFeatures(user._id);
      if (featureResponse?.Features) {
        sessionStorage.setItem(
          "Features",
          JSON.stringify(featureResponse.Features),
        );
        dispatch(setRoleFeatures(featureResponse.Features));
      }

      await ChatServices.setStatus(user._id, "Online");
      try {
        await addUserLogs({
          userId: user._id,
          organizationId: user.organizationId,
          actionType: "login",
        });
      } catch {
        toast.error("Error in saving user logs.");
      }

      if (user.isAdmin && !user.isSubAdmin) history.push("/admindashboard");
      else if (!user.isAdmin && !user.isSubAdmin)
        window.location.href = "/dashboard";
      else history.push("/subAdminDashboard");
    } catch {
      toast.error("Login failed");
    } finally {
      setLoading(false);
    }
  }

  const getCms = async () => {
    const c = await getHomeCMS();
    setCms(c.data);
  };

  function _handleKeyDown(e) {
    if (e.key === "Enter") handleLogin();
  }

  (function (d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  })(document, "script", "facebook-jssdk");

  return (
    <ThemeProvider theme={theme}>
      {/* ── Google Fonts ── */}
      <style>{`
               .login-card-wg {
          animation: cardIn 0.85s cubic-bezier(0.16,1,0.3,1) forwards;
  
          transition: transform 0.5s ease, box-shadow 0.5s ease;
          position: relative;
          z-index: 10;
        }
        // .login-card-wg:hover {
        //   transform: perspective(900px) rotateX(0deg) translateY(-6px) scale(1.005) !important;
        //   box-shadow:
        //     0 2px 0 rgba(33,150,243,0.6),
        //     0 20px 60px rgba(25,118,210,0.3),
        //     0 4px 24px rgba(33,150,243,0.2),
        //     inset 0 1px 0 rgba(255,255,255,0.9) !important;
        // }
        // .login-card-wg:hover .card-top-bar { animation: topBarGlow 1.4s ease infinite; }

               
        .blue-shimmer-btn {
          background: linear-gradient(270deg,#0D47A1,#1976D2,#64B5F6,#1976D2,#0D47A1) !important;
          background-size: 400% 400% !important;
          animation: btnShimmer 3.5s ease infinite !important;
          color: white !important;
          font-family: 'Montserrat', sans-serif !important;
          font-weight: 700 !important;
          letter-spacing: 0.22em !important;
          font-size: 0.78rem !important;
          border-radius: 12px !important;
          border: none !important;
          padding: 13px 0 !important;
          box-shadow: 0 4px 20px rgba(25,118,210,0.4), inset 0 1px 0 rgba(255,255,255,0.3) !important;
          transition: transform 0.25s ease, box-shadow 0.25s ease !important;
          text-shadow: 0 1px 3px rgba(0,20,80,0.4) !important;
        }
        .blue-shimmer-btn:hover {
          transform: translateY(-3px) !important;
          box-shadow: 0 10px 36px rgba(25,118,210,0.55), 0 0 20px rgba(33,150,243,0.3) !important;
        }

        .social-wg {
          display:flex; align-items:center; justify-content:center; gap:10px;
          width:100%; padding:10px 16px;
          background: rgba(255,255,255,0.85);
          border: 1.5px solid rgba(25,118,210,0.22);
          border-radius: 12px;
          color: #000000;
          cursor:pointer;
          transition: all 0.3s ease;
          font-family:'Montserrat',sans-serif; font-size:0.78rem;
          letter-spacing:0.06em; text-decoration:none;
          backdrop-filter:blur(8px);
          margin-top: 10px;
        }
        .social-wg:hover {
          background: rgba(33,150,243,0.1);
          border-color: #1976D2;
          transform: translateY(-2px);
          box-shadow: 0 6px 18px rgba(25,118,210,0.2);
          color: #0D47A1;
        }
        .social-wg img { height:22px; width:auto; }
        .social-wg strong { color:#1976D2; }

        .left-intro { animation: labelIn 0.7s cubic-bezier(0.16,1,0.3,1) forwards; }
        .err-text {
          color:#B71C1C; font-size:0.7rem; margin-top:3px; margin-left:4px;
          font-family:'Montserrat',sans-serif;
        }
      `}</style>

      <Box
        onKeyDown={_handleKeyDown}
        sx={{
          minHeight: "100vh",
          width: "100%",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "'Montserrat',sans-serif",
          overflow: "hidden",
        }}
      >
        <Loader loading={loading} />
        <ToastContainer
          position="top-right"
          toastStyle={{
            background: "rgba(227,242,253,0.97)",
            border: "1px solid rgba(25,118,210,0.4)",
            color: "#0D47A1",
            fontFamily: "'Montserrat',sans-serif",
            boxShadow: "0 8px 24px rgba(25,118,210,0.2)",
          }}
        />

        {/* ── Animated background ── */}
        <AnimatedBackground />

        {/* ── Logo at Top-Left ── */}
        <Box
          sx={{
            position: "absolute",
            top: 24,
            left: 32,
            zIndex: 10,
          }}
        >
          <Link to="/">
            <img
              src={PoetNewlogopen}
              alt="Logo"
              style={{
                height: 150,
                width: "auto",
                objectFit: "contain",
                filter: "drop-shadow(0 2px 8px rgba(25,118,210,0.3))",
              }}
            />
          </Link>
        </Box>

        {/* ── Centered Card with 3D Animation Outside ── */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            zIndex: 2,
            px: 2,
          }}
        >
          {/* Card Container with 3D Wrapper */}
          <Box
            className="card-3d-wrapper"
            sx={{
              width: "100%",
              maxWidth: 480,
              // perspective: "1200px",
            }}
          >
            {/* 3D Animation Rings Outside Card */}
            <Box className="card-3d-ring-outer" />
            <Box className="card-3d-ring-middle" />
            <Box className="card-3d-ring-inner" />

            {/* Floating Orbs */}
            <Box className="floating-orb-1" />
            <Box className="floating-orb-2" />
            <Box className="floating-orb-3" />
            <Box className="floating-orb-4" />

            {/* Login Card */}
            <Box
              sx={
                {
                  // perspective: "900px",
                }
              }
            >
              <Box
                className="login-card-wg"
                sx={{
                  background: "rgba(255,255,255,0.95)",
                  border: "1.5px solid rgba(25,118,210,0.35)",
                  borderRadius: "35px",
                  px: { xs: 3.5, sm: 4, md: 4.5 },
                  py: { xs: 4, sm: 4.5, md: 5 },
                  position: "relative",
                  backdropFilter: "blur(20px)",
                  WebkitBackdropFilter: "blur(20px)",
                  boxShadow: `
                  0 2px 0 rgba(33,150,243,0.5),
                  0 12px 40px rgba(25,118,210,0.2),
                  0 2px 12px rgba(33,150,243,0.15),
                  inset 0 1px 0 rgba(255,255,255,0.95),
                  inset 0 -1px 0 rgba(25,118,210,0.1)
                `,
                  // transform: "perspective(900px) rotateX(3deg)",
                  transform: "none",
                }}
              >
                {/* Title */}
                <Box sx={{ textAlign: "center", mb: 3.5 }}>
                  <Typography
                    sx={{
                      fontFamily: "'Cormorant Garamond',Georgia,serif",
                      fontSize: { xs: "1.8rem", sm: "2rem", md: "2.2rem" },
                      fontWeight: 700,
                      letterSpacing: "0.08em",
                      background:
                        "linear-gradient(135deg,#0D47A1,#1976D2 45%,#64B5F6 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      lineHeight: 1.2,
                    }}
                  >
                    Welcome Back
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "'Montserrat',sans-serif",
                      fontSize: "0.68rem",
                      letterSpacing: "0.38em",
                      color: "rgb(10, 100, 190)",
                      textTransform: "uppercase",
                      mt: 0.8,
                    }}
                  >
                    Sign in to continue
                  </Typography>
                </Box>

                {/* Email - FIXED with ref and blur handler */}
                <Box sx={{ mb: 2.2 }}>
                  <TextField
                    fullWidth
                    label="Email Address"
                    type="email"
                    value={email}
                    onChange={handleEmail}
                    onBlur={handleEmailBlur}
                    autoComplete="off"
                    size="small"
                    variant="outlined"
                    inputRef={emailInputRef}
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      "& input": {
                        caretColor: "#000000",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email
                            sx={{
                              fontSize: "1rem",
                              color: "rgba(25,118,210,0.7)",
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                  {emailerrors?.trim() && (
                    <Typography className="err-text">{emailerrors}</Typography>
                  )}
                </Box>

                {/* Password - FIXED with ref and blur handler */}
                <Box sx={{ mb: 1.8 }}>
                  <TextField
                    fullWidth
                    label="Password"
                    type={showPass ? "text" : "password"}
                    value={password}
                    onChange={handlePassword}
                    onBlur={handlePasswordBlur}
                    autoComplete="off"
                    size="small"
                    variant="outlined"
                    inputRef={passwordInputRef}
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      "& input": {
                        caretColor: "#000000",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Lock
                            sx={{
                              fontSize: "1rem",
                              color: "rgba(25,118,210,0.7)",
                            }}
                          />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPass((p) => !p)}
                            edge="end"
                            sx={{
                              color: "rgba(25,118,210,0.6)",
                              "&:hover": { color: "#1976D2" },
                            }}
                          >
                            {showPass ? (
                              <VisibilityOff fontSize="small" />
                            ) : (
                              <Visibility fontSize="small" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {passerrors && (
                    <Typography className="err-text">{passerrors}</Typography>
                  )}
                </Box>

                {/* Remember + Forgot */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2.5,
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={isRememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                        sx={{
                          color: "#000000",
                          "&.Mui-checked": { color: "#1976D2" },
                          p: 0.5,
                        }}
                      />
                    }
                    label={
                      <Typography
                        sx={{
                          fontFamily: "'Montserrat',sans-serif",
                          fontSize: "0.74rem",
                          color: "#000000",
                          letterSpacing: "0.04em",
                        }}
                      >
                        Remember me
                      </Typography>
                    }
                  />
                  <Link
                    to="/forgotpassword"
                    style={{
                      color: "#1976D2",
                      fontFamily: "'Montserrat',sans-serif",
                      fontSize: "0.74rem",
                      textDecoration: "none",
                      opacity: 0.8,
                    }}
                  >
                    Forgot Password?
                  </Link>
                </Box>

                {/* Login Button */}
                <Button
                  fullWidth
                  className="blue-shimmer-btn"
                  onClick={handleLogin}
                  disableRipple
                  sx={{
                    py: 1.3,
                    fontSize: "0.8rem !important",
                  }}
                >
                  SIGN IN
                </Button>

                {/* Divider */}
                <Box sx={{ display: "flex", alignItems: "center", my: 2.5 }}>
                  <Box
                    sx={{
                      flex: 1,
                      height: "1px",
                      background: "rgb(3, 127, 251)",
                    }}
                  />
                  <Typography
                    sx={{
                      px: 1.5,
                      fontFamily: "'Montserrat',sans-serif",
                      fontSize: "0.68rem",
                      letterSpacing: "0.3em",
                      color: "rgb(3, 127, 251)",
                      textTransform: "uppercase",
                    }}
                  >
                    OR
                  </Typography>
                  <Box
                    sx={{
                      flex: 1,
                      height: "1px",
                      background: "rgb(3, 127, 251)",
                    }}
                  />
                </Box>

                {/* Social */}
                <a
                  href={`${configdata.apiUrl}/auth/google/callback`}
                  className="social-wg"
                >
                  <img src={googleSignin} alt="Google" />
                  <span>
                    Continue with <strong>Google</strong>
                  </span>
                </a>
                <a
                  href={`${configdata.apiUrl}/auth/facebook`}
                  className="social-wg"
                >
                  <img src={facebookSignin} alt="Facebook" />
                  <span>
                    Continue with <strong>Facebook</strong>
                  </span>
                </a>
                <a
                  href={`${configdata.apiUrl}/auth/microsoft`}
                  className="social-wg"
                >
                  <img
                    src={microsoft365Signin}
                    alt="Microsoft 365"
                    style={{ height: 22 }}
                  />
                  <span>
                    Continue with <strong>Microsoft 365</strong>
                  </span>
                </a>

                {/* Sign up */}
                <Typography
                  sx={{
                    textAlign: "center",
                    mt: 2.5,
                    fontFamily: "'Montserrat',sans-serif",
                    fontSize: "0.75rem",
                    color: "#000000",
                    letterSpacing: "0.04em",
                  }}
                >
                  Don&apos;t have an account?{" "}
                  <Link
                    to="/signup"
                    style={{
                      color: "#1976D2",
                      textDecoration: "none",
                      fontWeight: 700,
                    }}
                  >
                    Create Account
                  </Link>
                </Typography>

                {/* <Typography
                  sx={{
                    textAlign: "center",
                    mt: 1.2,
                    fontFamily: "'Montserrat',sans-serif",
                    fontSize: "0.68rem",
                    color: "rgba(13,71,161,0.3)",
                    letterSpacing: "0.04em",
                  }}
                >
                  <Link
                    to="/privacypolicy"
                    target="_blank"
                    style={{
                      color: "rgba(25,118,210,0.4)",
                      textDecoration: "none",
                    }}
                  >
                    Terms of Use · Privacy Policy
                  </Link>
                </Typography> */}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
  setUserFeatures: (features) => dispatch(setUserFeatures(features)),
  setRoleFeatures: (roleFeatures) => dispatch(setRoleFeatures(roleFeatures)),
  setSubscriptionPlan: (plan) => dispatch(setSubscriptionPlan(plan)),
});

export default connect(null, mapDispatchToProps)(withRouter(Login));
